/**
 * pi-reviews-grid – Custom element host for mobile horizontal track (scroll / snap).
 * Safe for multiple instances and Shopify theme editor section reloads.
 */
(function () {
  'use strict';

  var BP_ATTR = 'data-layout-bp';
  var SLIDER_ATTR = 'data-mobile-slider';

  function parseBp(el) {
    var v = el.getAttribute(BP_ATTR);
    var n = v ? parseInt(v, 10) : 990;
    return Number.isFinite(n) && n > 0 ? n : 990;
  }

  function isMobile(bp) {
    return window.matchMedia('(max-width: ' + (bp - 1) + 'px)').matches;
  }

  class PiReviewsGridSlider extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._onResize = function () {
        self._sync();
      };
      this._onScroll = function () {
        self._onScrollImpl();
      };
      this._onSectionLoad = function (e) {
        if (!e || !e.target || !e.target.contains) return;
        if (e.target.contains(self)) self._sync();
      };
      window.addEventListener('resize', this._onResize);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      this._sync();
      var track = this._track();
      if (track) track.addEventListener('scroll', this._onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      var track = this._track();
      if (track) track.removeEventListener('scroll', this._onScroll);
    }

    _track() {
      return this.querySelector('.pi-reviews__track');
    }

    _onScrollImpl() {
      /* Reserved for future progress / announcements */
    }

    _onResize() {
      this._sync();
    }

    _onScroll() {
      /* Reserved for future progress dots / aria live region */
    }

    _sync() {
      var bp = parseBp(this);
      var track = this._track();
      if (!track) return;

      var sliderOn = this.getAttribute(SLIDER_ATTR) === 'true';
      var mobile = isMobile(bp);

      this.setAttribute('data-active-slider', sliderOn && mobile ? 'true' : 'false');

      if (sliderOn && mobile) {
        track.setAttribute('tabindex', '0');
        track.setAttribute('role', 'region');
        track.setAttribute('aria-roledescription', 'carousel');
        var label = this.getAttribute('data-aria-label');
        if (label) track.setAttribute('aria-label', label);
      } else {
        track.removeAttribute('tabindex');
        track.removeAttribute('role');
        track.removeAttribute('aria-roledescription');
        track.removeAttribute('aria-label');
      }
    }
  }

  if (!customElements.get('pi-reviews-grid-slider')) {
    customElements.define('pi-reviews-grid-slider', PiReviewsGridSlider);
  }
})();
